import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";

const Section3 = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      exit="exit"
      variants={containerVariants}
      className="grid grid-cols-10  bg-customBgGray py-28">
      <div className="col-start-2 md:col-start-2 col-span-8  grid grid-cols-1 md:grid-cols-2 gap-24">
        <div className="flex flex-col text-customGray2 ">
          <motion.h2 variants={itemVariants} className="font-medium text-26">{t("rnd.vision.title")}</motion.h2>
          <motion.h3 variants={itemVariants} className="font-light text-20">
            {t("rnd.vision.text")}
          </motion.h3>
        </div>

        <div className="flex flex-col text-customGray2">
          <motion.h2 variants={itemVariants} className="font-medium text-26">{t("rnd.mission.title")}</motion.h2>
          <motion.h3 variants={itemVariants} className="font-light text-20">
            {t("rnd.mission.text")}
          </motion.h3>
        </div>
      </div>
    </motion.div>
  );
};

export default Section3;
